import { useTranslation } from "react-i18next"
import { Button, Form, Row } from 'react-bootstrap'

export default function FormCrop({submit, isNew, inputChange, state}) {
    const { t } = useTranslation()

    return (
        <>
            <Form onSubmit={submit}>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('crops.name')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='name' 
                        value={state.name || state.nameEdit ||  ''}
                        placeholder={t('crops.name')}
                        onChange={inputChange}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('crops.description')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='description' 
                        value={state.description || state.descriptionEdit ||  ''}
                        placeholder={t('crops.description')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Row className="text-left custom-card-header-list">
                    {
                        isNew === false
                        ?
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('crops.update')}</Button>
                        :
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('crops.new')}</Button>
                    }
                </Row>
            </Form>
        </>
    )    
}
